import type { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import {
  cardContainerClassName,
  cardHeaderClassName,
} from '~/components/common/sellerRowClasses';

type SellerAccordionRowProps = {
  testId?: string;
  disabled: boolean;
  expanded: boolean;
  onToggleExpand: () => void;
  highlighted: boolean;
  children: ReactNode;
  expandedContent: ReactNode;
};

export function SellerAccordionRow({
  testId,
  disabled,
  expanded,
  onToggleExpand,
  highlighted,
  children,
  expandedContent,
}: Readonly<SellerAccordionRowProps>) {
  return (
    <li className={cardContainerClassName(highlighted)}>
      <div className={cardHeaderClassName(disabled)}>
        <button
          type="button"
          data-testid={testId}
          disabled={disabled}
          onClick={onToggleExpand}
          aria-expanded={disabled ? undefined : expanded}
          className="flex min-w-0 flex-1 cursor-pointer items-center gap-3 text-left disabled:cursor-not-allowed disabled:opacity-60"
        >
          {children}
        </button>
        <button
          type="button"
          tabIndex={-1}
          aria-hidden="true"
          onClick={onToggleExpand}
          className={`shrink-0 cursor-pointer ${disabled ? 'invisible' : ''}`}
        >
          <ChevronDown
            size={18}
            className={`text-neut-400 transition-transform ${
              expanded ? '' : '-rotate-90'
            }`}
          />
        </button>
      </div>
      {!disabled && expanded && expandedContent}
    </li>
  );
}
